import React from 'react';
import './TutorMessage.css'
import splitHighlight from '../../splitHighlight';
function TutorMessage({message,orgName, orgLogo, heading, headingHighlight}) {
    const tutorMessageHeading = splitHighlight(
        heading || 'A special message from your Tutor',
        headingHighlight || 'message from your Tutor'
    );
    return (
        <div className="tutor-message-container">
            <div className="tutor-message-box">
                <div className="content-box">
                    <h1>{tutorMessageHeading.before}{tutorMessageHeading.highlight && <span>{tutorMessageHeading.highlight}</span>}{tutorMessageHeading.after}</h1>
                    <p>{message}</p>
                    <div className="content-icon">
                        <img src={orgLogo} alt="logo"/>
                        <h4>{orgName}</h4>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TutorMessage;
